// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__SG7cT","inputWrap":"CustomTip_inputWrap__V-iUw"};